import {yupResolver} from "@hookform/resolvers/yup";
import {Box, Grid, InputAdornment} from "@mui/material";
import {makeStyles} from "@mui/styles";
import _ from "lodash";

import React, {useEffect, useState} from "react";
import {useFieldArray, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import {RequestPaymentId} from "src/api/requestPaymentId";
import {colors} from "src/colors/colors";
import ButtonCommon from "src/commonStyles/button/button";
import ContainerContent from "src/commonStyles/container/containerContent/containerContent";
import SesstionTitle from "src/commonStyles/text/sessionTitile/sessionTitle";
import TextBase from "src/commonStyles/text/textBase/textBase";
import TextSub from "src/commonStyles/text/textSub/textSub";
import TextTitle from "src/commonStyles/text/textTitle/textTitle";
import ControllerCheckbox from "src/components/Form/ControllerCheckbox";
import ControllerNumberField from "src/components/Form/ControllerNumberField";
import ControllerRadio from "src/components/Form/ControllerRadio";
import {CALLBACK_URL, FR_HEADER} from "src/const/const-from-env";
import {FontSize} from "src/const/font";
import useCheckMobile from "src/hook/useCheckMobile";
import {IInquiryPolicyResponseData} from "src/interface/inforPay";
import {IRequestInitPayment, IRequestPaymentID} from "src/interface/typePay";
import {useCheckLoading} from "src/providers/checkLoadingProvider";
import DateFns from "src/utils/DateFns";
import {DatePattend} from "src/utils/DatePattend";
import {numberWithCommas} from "src/utils/helper";
import PopupService from "src/utils/PopupService";
import * as yup from "yup";

const validationSchema = yup.object().shape({
  type: yup.string(),
});

interface IDuePremium {
  value: boolean;
}

interface IForm {
  type: any;
  duePremium: IDuePremium[];
  additionally: any;
  supplement: any;
  changePeriodically: any;
  restoreFee: any;
}

interface IProps {
  hasPolicy?: boolean;
  dataFee?: IInquiryPolicyResponseData;
  frSystm?: string;
  callbackUrl?: string;
}

const SelectFeeAll = (props: IProps) => {
  const {hasPolicy, dataFee, frSystm, callbackUrl} = props;

  return (
    <>
      {hasPolicy ? (
        <SelectFee data={dataFee} frSystm={frSystm} callbackUrl={callbackUrl}/>
      ) : (
        <SelectFeeNoPolicy data={dataFee} frSystm={frSystm} callbackUrl={callbackUrl}/>
      )}
    </>
  );
};

export default SelectFeeAll;

const SelectFeeNoPolicy = ({
                             data,
                             frSystm,
                             callbackUrl
                           }: { data: IInquiryPolicyResponseData, frSystm?: string, callbackUrl?: string }) => {
  const [totalFee, setTotalFee] = useState(0);
  const classes = useStyle();
  const navigate = useNavigate();
  const {setIsLoading} = useCheckLoading();

  useEffect(() => {
    const initial = Number(data?.initialPremium?.totalAmt) || 0;
    const topup = Number(data?.initialPremium?.topupAmt) || 0;
    setTotalFee(initial + topup);
  }, [data]);

  const onSubmitData = async () => {
    const dataToRequestPayment: IRequestPaymentID = {
      feeType: "P001",
      idNumber: data?.idNumber,
      prdName: data?.prdName,
      phName: data?.phName,
      ccAllow: data?.ccAllow,
      savePaymentMethod: false,
      clientType: "webinapp",
      description: "",
      callbackURL: callbackUrl,
      userInfo: {
        email: data?.phEmail,
        accountId: data?.userInfo?.accountId
      },
      initialPremium: {
        id: `${data?.idNumber}_P001`,
        preMafTerTaxAmt: data?.initialPremium?.preMafTerTaxAmt,
        totalAmt: data?.initialPremium?.totalAmt,
        topupAmt: data?.initialPremium?.topupAmt,
      },
    };
    try {
      setIsLoading(true);
      const res = await RequestPaymentId(dataToRequestPayment, frSystm);
      if (res?.data?.data) {
        openInCurrentTab(res?.data?.data);
      }
    } catch (e) {
      setIsLoading(false);
      PopupService.instance.current.open({
        visible: true,
        content: "Đã có lỗi xảy ra",
        onOk: () => {
          PopupService.instance.current.close();
        },
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <ContainerContent>
        <SesstionTitle>Chọn loại phí</SesstionTitle>
        <Grid container>
          <Grid item xs={6} className={classes.rowItem}>
            <TextBase>Phí bảo hiểm tạm tính</TextBase>
          </Grid>
          <Grid
            item
            xs={6}
            className={`${classes.rowItem} ${classes.itemValue}`}>
            <TextBase>
              {data?.initialPremium?.preMafTerTaxAmt
                ? numberWithCommas(
                  Number(data?.initialPremium?.preMafTerTaxAmt).toString()
                )
                : 0} VND
            </TextBase>
          </Grid>
          <Grid item xs={6} className={classes.rowItem}>
            <TextBase>Phí bảo hiểm đóng thêm</TextBase>
          </Grid>
          <Grid
            item
            xs={6}
            className={`${classes.rowItem} ${classes.itemValue}`}>
            <TextBase>
              {data?.initialPremium?.topupAmt
                ? numberWithCommas(
                  Number(data?.initialPremium?.topupAmt).toString()
                )
                : 0} VND
            </TextBase>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6}>
            <SesstionTitle className={classes.totalFeeLeft}>
              Tổng số tiền thanh toán
            </SesstionTitle>
          </Grid>
          <Grid item xs={6}>
            <SesstionTitle
              className={classes.totalFeeRight}
              style={{
                overflowWrap: "break-word",
                maxWidth: `${window.innerWidth / 2}px`,
              }}>
              {numberWithCommas(
                Number(data?.initialPremium?.totalAmt).toString()
              )} VND
            </SesstionTitle>
          </Grid>
        </Grid>
      </ContainerContent>
      <div className={`${classes.buttonContainer} flex-col md:flex-row`}>
        <div className="mb-2 md:mb-0 md:mr-6 flex justify-center order-2 md:order-1">
          <ButtonCommon
            onEvent={() => navigate(frSystm ? `/?frSystm=${frSystm}` : '/')}
            style={{
              paddingLeft: 90,
              paddingRight: 90,
              marginRight: '10px'
            }}>
            Quay lại
          </ButtonCommon>
        </div>
        <div className="mb-2 md:mb-0 md:mr-6 flex justify-center order-1 md:order-2">
          <ButtonCommon
            disabled={!totalFee}
            onEvent={onSubmitData}
            style={{
              paddingLeft: 90,
              paddingRight: 90,
              marginRight: '10px'
            }}>
            Tiếp tục thanh toán
          </ButtonCommon>
        </div>
      </div>
    </>
  );
};

const SelectFee = ({
                     data: dataRaw,
                     frSystm,
                     callbackUrl
                   }: { data: IInquiryPolicyResponseData, frSystm: string, callbackUrl?: string }) => {

  const checkDuePremiumsByDueDate = (): boolean => {
    const duePremiums = dataRaw?.duePremium;
    const queryDate = new Date();
    queryDate.setHours(0, 0, 0, 0);

    if (!duePremiums || duePremiums.length === 0) {
      return false;
    }
    return duePremiums.some((item) => {
      if (!item.dueFrom) {
        return false;
      }
      const dueToDate = new Date(item.dueFrom);
      dueToDate.setHours(0, 0, 0, 0);

      return dueToDate < queryDate;
    });
  };
  
  const initialSuspense = Number(dataRaw?.suspenseAmt) || 0;
  let cumulativeDue = 0;
  const newDue = [];

  dataRaw?.duePremium?.forEach((item) => {
    // Skip items with null or undefined dueFrom
    if (!item.dueFrom) {
      return;
    }

    const dueAmt = Number(item.dueAmt) || 0;
    cumulativeDue += dueAmt;

    // Only add to newDue if cumulative amount exceeds suspense
    // if (cumulativeDue > initialSuspense) {
    //   newDue.push(item);
    // }
      newDue.push(item);
  });

  const data: IInquiryPolicyResponseData = {
    ...dataRaw,
    duePremium: newDue,
    // Keep original suspenseAmt from API
    suspenseAmt: dataRaw?.suspenseAmt,
  };
  const navigate = useNavigate();
  const {setIsLoading} = useCheckLoading();
  const [totalFeeFirst, setTotalFeeFirst] = useState(0);
  const [totalFee, setTotalFee] = useState(0);
  const [displaySuspenseAmt, setDisplaySuspenseAmt] = useState(Number(dataRaw?.suspenseAmt) || 0);
  const hasDueFee = data?.duePremium?.some((item) => item.premiumType === "due");
  const range = {
    min: Number(data?.topup.minTopup),
    max: Number(data?.topup.maxTopup),
  };
  const classes = useStyle();
  const isMobile = useCheckMobile();
  const {
    control,
    handleSubmit,
    resetField,
    watch,
    setValue,
    getValues,
  } = useForm<IForm>({
    mode: "all",
    resolver: yupResolver(validationSchema),
    defaultValues: {
      ...validationSchema.getDefault(),
      type: undefined,
      additionally: undefined,
      duePremium: data?.duePremium?.map((item, index) => ({ value: !index })),
    },
  });

  const { fields } = useFieldArray({ control, name: "duePremium" });

  const checkDisabledButton = () => {
    const isP003 = watch("type") === "P003";
    const isP004 = watch("type") === "P004";
    const add = Number(watch("additionally")) || 0;
    const restore = Number(watch("restoreFee")) || 0;

    const isP003Invalid = isP003 && watch("additionally") && (add < range.min || add > range.max || (add % 100000 !== 0));
    const isP004Invalid = isP004 && watch("restoreFee") && restore > 0 && (restore % 1000 !== 0);

    return isP003Invalid || isP004Invalid;
  };


  const options = [
      (!_.isEmpty(data?.duePremium) && data?.status?.toUpperCase() === "ACTIVE") && {
      label: "Phí bảo hiểm định kỳ",
      value: "P002",
      subContent: (
        <Box ml={4}>
          {[...fields]?.map((item, index) => {
            const dueFrom = data?.duePremium?.[index]?.dueFrom;
            if (!dueFrom) return null;

            return (
              <Box key={item.id ?? index}>
                <ControllerCheckbox
                  label={
                    <TextBase>
                      {DateFns.format(
                        new Date(dueFrom),
                        DatePattend.DayMonthYear
                      )}
                      {" : "}
                      <span style={{fontWeight: "600"}}>
                        {`${numberWithCommas(
                          Number(data?.duePremium[index]?.dueAmt).toString()
                        )} VND`}
                      </span>
                    </TextBase>
                  }
                  control={control}
                  name={`duePremium.${index}.value`}
                  onChangeSelect={(e) => {
                    [...fields]?.forEach((item, num) => {
                      if (e && num <= index) {
                        setValue(`duePremium.${num}.value`, e);
                      } else if (!e && num >= index) {
                        setValue(`duePremium.${num}.value`, e);
                      }
                    });
                  }}
                />
              </Box>
            );
          })}
        </Box>
      ),
    },

      (Boolean(Number(data?.topup?.maxTopup)) && !checkDuePremiumsByDueDate() && data?.status?.toUpperCase() === "ACTIVE") && {
      label: "Phí bảo hiểm đóng thêm",
      value: "P003",
      subContent: (
        <div className={classes.input}>
          <ControllerNumberField
            control={control}
            inputProps={{maxLength: 19}}
            name={"additionally"}
            className={classes.custome}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{
                    background: colors.background.gray,
                    maxHeight: "unset",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    display: "flex",
                    borderTopRightRadius: "15px",
                    borderBottomRightRadius: "15px",
                    alignSelf: "right",
                    fontWeight: 700,
                    fontSize: {md: "18px", xs: "12px"},
                  }}>
                  <Box className={classes.iconVND}>VND</Box>
                </InputAdornment>
              ),
            }}
          />
          <div style={{paddingTop: "5px"}}>
            <TextSub
              className={
                watch("type") === "P003" &&
                watch("additionally") &&
                (Number(watch("additionally")) < range.min ||
                  Number(watch("additionally")) > range.max ||
                  Number(watch("additionally")) % 100000 !== 0)
                  ? classes.errorText
                  : ""
              }
            >
              Phí bảo hiểm đóng thêm trong khoảng từ {numberWithCommas(Number(range.min) || 0)} VND đến {numberWithCommas(Number(range.max) || 0)} VND và là bội
              số của 100,000 VND
            </TextSub>
          </div>
        </div>
      ),
      positionSubContent: isMobile ? "bottom" : "right",
    },
    (data?.addRider?.totalAmt != null && data?.addRider?.totalAmt != 0) && {
      label: "Phí bổ sung",
      value: "P005",
      subContent: (
        <div className={classes.input}>
          {(Number(data?.addRider?.totalAmt) === 0 || !Boolean(data?.addRider?.totalAmt)) ? (
            <ControllerNumberField
              control={control}
              name={"supplement"}
              inputProps={{maxLength: 19}}
              className={classes.custome}
              sx={{
                border: "none",
                marginBottom: "10px",
                paddingRight: 0,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{
                      background: colors.background.gray,
                      maxHeight: "unset",
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      display: "flex",
                      borderTopRightRadius: "15px",
                      borderBottomRightRadius: "15px",
                      alignSelf: "right",
                      fontWeight: 700,
                      fontSize: {md: "18px", xs: "12px"},
                    }}>
                    <Box className={classes.iconVND}>VND</Box>
                  </InputAdornment>
                ),
              }}
            />
          ) : (
            <Box
              className={`${classes.itemValue}`}
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "flex-end",
                fontWeight: 700,
              }}>
              {numberWithCommas(Number(data?.addRider?.totalAmt) || 0)} VND
            </Box>
          )}
        </div>
      ),
      positionSubContent: isMobile ? "bottom" : "right",
    },
    (data?.changePaymentFrequency?.totalAmt != null) && {
      label: "Phí thay đổi định kỳ đóng phí",
      value: "P006",
      subContent: (
        <div className={classes.input}>
          {(Number(data?.changePaymentFrequency?.totalAmt) === 0 || !Boolean(data?.changePaymentFrequency?.totalAmt)) ? (
            <ControllerNumberField
              control={control}
              inputProps={{maxLength: 19}}
              name={"changePeriodically"}
              className={classes.custome}
              sx={{
                border: "none",
                marginBottom: "10px",
                paddingRight: 0,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{
                      background: colors.background.gray,
                      maxHeight: "unset",
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      display: "flex",
                      borderTopRightRadius: "15px",
                      borderBottomRightRadius: "15px",
                      alignSelf: "right",
                    }}
                    style={{}}>
                    <Box className={classes.iconVND}>VND</Box>
                  </InputAdornment>
                ),
              }}
            />
          ) : (
            <Box
              className={`${classes.itemValue}`}
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "flex-end",
                fontWeight: 700,
              }}>
              {numberWithCommas(
                Number(data?.changePaymentFrequency?.totalAmt).toString()
              )} VND
            </Box>
          )}
        </div>
      ),
      positionSubContent: isMobile ? "bottom" : "right",
    },
    data?.reinstatementRequired && {
      label: "Phí khôi phục",
      value: "P004",
      subContent: (
        <div className={classes.input}>
          {Number(data?.reinstate?.totalAmt) === 0 ? (
            <>
              <ControllerNumberField
                control={control}
                name={"restoreFee"}
                inputProps={{maxLength: 19}}
                className={classes.custome}
                sx={{
                  border: "none",
                  marginBottom: "10px",
                  paddingRight: 0,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{
                        background: colors.background.gray,
                        maxHeight: "unset",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        display: "flex",
                        borderTopRightRadius: "15px",
                        borderBottomRightRadius: "15px",
                        alignSelf: "right",
                      }}
                      style={{}}>
                      <Box className={classes.iconVND}>VND</Box>
                    </InputAdornment>
                  ),
                }}
              />
              <div style={{paddingTop: "5px"}}>
                <TextSub
                  className={
                    watch("type") === "P004" &&
                    watch("restoreFee") &&
                    Number(watch("restoreFee")) % 1000 !== 0
                      ? classes.errorText
                      : ""
                  }
                >
                  Phí khôi phục phải là bội số của 1,000 VND
                </TextSub>
              </div>
            </>
          ) : (
            <Box
              className={`${classes.itemValue}`}
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "flex-end",
                fontWeight: 700,
              }}>
              {numberWithCommas(Number(data?.reinstate?.totalAmt) || 0)} VND
            </Box>
          )}
        </div>
      ),
      positionSubContent: isMobile ? "bottom" : "right",
    },
  ];
  const makeData = () => {
    if (watch("type") === "P001") {
      return {
        initialPremium: {
          id: `${data?.idNumber}_${watch("type")}`,
          preMafTerTaxAmt: data?.initialPremium?.preMafTerTaxAmt,
          totalAmt: data?.initialPremium?.totalAmt,
        },
      };
    }
    if (watch("type") === "P002") {
      const P002 = [];
      watch("duePremium")?.forEach((item, index) => {
        if (item.value) {
          P002.push({
            id:
              data?.idNumber +
              "_" +
              watch("type") +
              "_" +
              data?.duePremium[index].dueTo,
            premiumType: data?.duePremium[index].premiumType,
            dueFrom: data?.duePremium[index].dueFrom,
            dueTo: data?.duePremium[index].dueTo,
            dueAmt: data?.duePremium[index].dueAmt,
          });
        }
      });
      return {
        duePremium: {
          suspenseAmt: data?.suspenseAmt,
          duePremiumInfo: P002,
        },
      };
    }
    if (watch("type") === "P003") {
      return {
        topup: {
          id: `${data?.idNumber}_${watch("type")}`,
          amount: totalFee,
        },
      };
    }
    if (watch("type") === "P004") {
      return {
        reInstate: {
          id: `${data?.idNumber}_${watch("type")}`,
          totalAmt: totalFee,
        },
      };
    }
    if (watch("type") === "P005") {
      return {
        addRider: {
          id: `${data?.idNumber}_${watch("type")}`,
          totalAmt: totalFee,
        },
      };
    }
    if (watch("type") === "P006") {
      return {
        changePaymentFrequency: {
          id: `${data?.idNumber}_${watch("type")}`,
          totalAmt: totalFee,
        },
      };
    }
  };
  const onSubmit = async (_dataForm: any) => {
    console.log(data)
    const dataToSend: IRequestInitPayment = {
      userInfo: {
        accountId: data?.userInfo?.accountId,
        tokenId: null,
        email: data?.phEmail,
      },
      policy: {
        feeType: watch("type"),
        idNumber: `${data?.idNumber}`,
        prdName: data?.prdName,
        productCode: data?.productCode,
        phName: data?.phName,
        ccAllow: "Y",
        orderId: `${data?.idNumber}_${FR_HEADER}_${watch(
          "type"
        )}_${new Date().getTime()}`,

        ...makeData(),
      },
      callbackUrl: CALLBACK_URL,
      savePaymentMethod: false,
      clientType: "webinapp",
      description: `${data?.idNumber}_${FR_HEADER}_${watch(
        "type"
      )}_${new Date().getTime()}`,
    };

    const dataToRequestPayment: IRequestPaymentID = {
      feeType: dataToSend?.policy?.feeType,
      idNumber: dataToSend?.policy?.idNumber,
      prdName: dataToSend?.policy?.prdName,
      phName: dataToSend?.policy?.phName,
      ccAllow: dataToSend?.policy?.ccAllow,
      savePaymentMethod: `${dataToSend?.savePaymentMethod}`,
      clientType: dataToSend?.clientType,
      description: dataToSend?.description,
      callbackURL: callbackUrl,
      userInfo: {
        email: dataToSend?.userInfo?.email,
        accountId: dataToSend?.userInfo?.accountId,
      },
      initialPremium: {
        id: dataToSend?.policy?.initialPremium?.id,
        preMafTerTaxAmt: dataToSend?.policy?.initialPremium?.preMafTerTaxAmt,
        totalAmt: dataToSend?.policy?.initialPremium?.totalAmt || "0",
        topupAmt: dataToSend?.policy?.initialPremium?.topupAmt || "0",
      },
      duePremium: {
        suspenseAmt: dataToSend?.policy?.duePremium?.suspenseAmt || "0",
        duePremiumInfo: dataToSend?.policy?.duePremium?.duePremiumInfo,
      },
      topUp: {
        id: dataToSend?.policy?.topup?.id,
        amount: dataToSend?.policy?.topup?.amount || "0",
      },
      reInstate: {
        id: dataToSend?.policy?.reInstate?.id,
        amount: dataToSend?.policy?.reInstate?.totalAmt || "0",
      },
      addRider: {
        id: dataToSend?.policy?.addRider?.id,
        amount: dataToSend?.policy?.addRider?.totalAmt || "0",
      },
      changePaymentFrequency: {
        id: dataToSend?.policy?.changePaymentFrequency?.id,
        amount: dataToSend?.policy?.changePaymentFrequency?.totalAmt || "0",
      },
    };
    try {
      setIsLoading(true);
      const res = await RequestPaymentId(dataToRequestPayment, frSystm);
      if (res?.data?.data) {
        openInCurrentTab(res?.data?.data);
      }
    } catch (e) {
      setIsLoading(false);
      PopupService.instance.current.open({
        visible: true,
        content: "Đã có lỗi xảy ra",
        onOk: () => {
          PopupService.instance.current.close();
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Reset fields when switching fee types
    if (watch("type") !== "P002") {
      setTotalFeeFirst(0);
      resetField("duePremium");
    }
    if (watch("type") !== "P003") {
      resetField("additionally");
    }
    if (watch("type") !== "P005") {
      resetField("supplement");
    }
    if (watch("type") !== "P006") {
      resetField("changePeriodically");
    }
    if (watch("type") !== "P004") {
      resetField("restoreFee");
    }

    // Calculate total fee based on selected fee type
    let calculatedFee = 0;

    if (watch("type") === "P002") {
      // Calculate P002 from selected checkboxes
      const dueVals = watch("duePremium") || [];
      dueVals.forEach((item, index) => {
        if (item?.value && data?.duePremium[index]) {
          calculatedFee += Number(data?.duePremium[index]?.dueAmt) || 0;
        }
      });
      setTotalFeeFirst(calculatedFee);
    } else if (watch("type") === "P003") {
      // P003 - user input
      calculatedFee = Number(watch("additionally")) || 0;
    } else if (watch("type") === "P004") {
      // P004 - can be from API or user input
      if (Number(data?.reinstate?.totalAmt) !== 0 && Boolean(data?.reinstate?.totalAmt)) {
        calculatedFee = Number(data?.reinstate?.totalAmt) || 0;
      } else {
        calculatedFee = Number(watch("restoreFee")) || 0;
      }
    } else if (watch("type") === "P005") {
      // P005 - can be from API or user input
      if (Number(data?.addRider?.totalAmt) !== 0 && Boolean(data?.addRider?.totalAmt)) {
        calculatedFee = Number(data?.addRider?.totalAmt) || 0;
      } else {
        calculatedFee = Number(watch("supplement")) || 0;
      }
    } else if (watch("type") === "P006") {
      // P006 - can be from API or user input
      if (Number(data?.changePaymentFrequency?.totalAmt) !== 0 && Boolean(data?.changePaymentFrequency?.totalAmt)) {
        calculatedFee = Number(data?.changePaymentFrequency?.totalAmt) || 0;
      } else {
        calculatedFee = Number(watch("changePeriodically")) || 0;
      }
    }

    caculated(calculatedFee);
  }, [
    watch("type"),
    watch("additionally"),
    watch("supplement"),
    watch("changePeriodically"),
    watch("restoreFee"),
    JSON.stringify(watch("duePremium")),
  ]);


  const caculated = (dataNew) => {
    const numDataNew = Number(dataNew) || 0;
    const suspenseAmount = Number(data?.suspenseAmt) || 0;

    // Code cũ - P003 không trừ phí còn dư
    // if (watch("type") === "P003") {
    //   // P003 (Phí bảo hiểm đóng thêm) doesn't use suspenseAmt
    //   setTotalFee(numDataNew);
    //   setDisplaySuspenseAmt(suspenseAmount); // Keep original
    // } else if (watch("type") && numDataNew > 0) {
    //   // All other fee types (P002, P004, P005, P006) - apply suspenseAmt deduction
    //   const calculatedFee = numDataNew - suspenseAmount;
    //   if (calculatedFee <= 0) {
    //     setTotalFee(0);
    //     setDisplaySuspenseAmt(suspenseAmount - numDataNew); // Remaining after deduction
    //   } else {
    //     setTotalFee(calculatedFee);
    //     setDisplaySuspenseAmt(0); // All suspense used
    //   }
    // } else {
    //   // No fee type selected or amount is 0
    //   setTotalFee(0);
    //   setDisplaySuspenseAmt(suspenseAmount); // Show original
    // }

    // Code mới - Tất cả các loại phí đều trừ phí còn dư
    if (watch("type") && numDataNew > 0) {
      // All fee types (P002, P003, P004, P005, P006) - apply suspenseAmt deduction
      const calculatedFee = numDataNew - suspenseAmount;
      if (calculatedFee <= 0) {
        setTotalFee(0);
        setDisplaySuspenseAmt(suspenseAmount - numDataNew); // Remaining after deduction
      } else {
        setTotalFee(calculatedFee);
        setDisplaySuspenseAmt(0); // All suspense used
      }
    } else {
      // No fee type selected or amount is 0
      setTotalFee(0);
      setDisplaySuspenseAmt(suspenseAmount); // Show original
    }
  };

  return (
    <>
      <ContainerContent>
        <SesstionTitle>Chọn loại phí</SesstionTitle>
        <Grid container>
          <Grid item xs={6}>
            <TextTitle>Số phí còn dư</TextTitle>
          </Grid>
          <Grid item xs={6}>
            <TextTitle className={classes.feeRemainingRight}>
              {`${numberWithCommas(displaySuspenseAmt)} VND`}
            </TextTitle>
          </Grid>
        </Grid>
        <div style={{paddingTop: "10px"}}>
          <ControllerRadio control={control} name={"type"} options={options}/>
        </div>
        <Grid container>
          <Grid item xs={6}>
            <SesstionTitle className={classes.totalFeeLeft}>
              Tổng số tiền thanh toán
            </SesstionTitle>
          </Grid>
          <Grid item xs={6}>
            <SesstionTitle
              className={classes.totalFeeRight}
              style={{
                overflowWrap: "break-word",
                maxWidth: `${window.innerWidth / 2}px`,
              }}>
              {`${numberWithCommas(totalFee)} VND`}
            </SesstionTitle>
          </Grid>
        </Grid>
      </ContainerContent>
      <div className={`${classes.buttonContainer} flex-col md:flex-row`}>
        <div className="mb-2 md:mb-0 md:mr-6 order-2 md:order-1 flex justify-center" style={{width: isMobile ? '100%' : 'auto'}}>
          <ButtonCommon
            onEvent={() => navigate(frSystm ? `/?frSystm=${frSystm}` : '/')}
            style={{
              paddingLeft: isMobile ? 0 : 90,
              paddingRight: isMobile ? 0 : 90,
              marginRight: isMobile ? 0 : '10px',
              width: isMobile ? '100%' : 'auto',
            }}>
            Quay lại
          </ButtonCommon>
        </div>
        <div className="mb-2 md:mb-0 md:mr-6 order-1 md:order-2 flex justify-center" style={{width: isMobile ? '100%' : 'auto'}}>
          <ButtonCommon
            disabled={totalFee <= 0 || checkDisabledButton()}
            onEvent={handleSubmit(onSubmit)}
            style={{
              paddingLeft: isMobile ? 0 : 90,
              paddingRight: isMobile ? 0 : 90,
              marginRight: isMobile ? 0 : '10px',
              width: isMobile ? '100%' : 'auto',
            }}>
            Tiếp tục thanh toán
          </ButtonCommon>
        </div>
      </div>
    </>
  );
};

const useStyle = makeStyles((theme) => {
  return {
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "20px",
      paddingBottom: "20px",
    },
    feeRemainingRight: {
      fontSize: FontSize.normal.p1,
      textAlign: "right",
      [theme.breakpoints.down("md")]: {
        fontSize: FontSize.normal.p4,
      },
    },
    custome: {
      "& .MuiTextField-root": {
        height: "100%",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderWidth: 0,
        border: "none",
        paddingRight: 0,
        "& ::before": {
          border: "none",
        },
      },
      "& .MuiInputBase-input:focus": {
        borderBottom: `1px solid ${colors.border.lightBlue}`,
      },
      "& .MuiInputBase-input": {
        borderBottom: "1px solid",
        paddingRight: "10px",
        height: "100%",
        textAlign: "right",
        [theme.breakpoints.down("md")]: {
          textAlign: "left",
        },
      },
      "& .MuiInputBase-root .MuiInputBase-input": {
        [theme.breakpoints.down("md")]: {
          textAlign: "left",
          padding: "5px",
        },
      },
      "& .MuiOutlinedInput-input": {
        [theme.breakpoints.down("md")]: {
          padding: 0,
        },
      },
      "& .MuiInputAdornment-root": {
        fontWeight: 700,
        margin: 0,
        height: "100%",
        padding: "14px 14px",
        [theme.breakpoints.down("md")]: {
          height: "24px",
          fontSize: "12px",
        },
      },
      "& .MuiInputBase-root": {
        paddingRight: 0,
      },
    },
    adornedEnd: {
      height: "48px",
    },
    input: {
      width: "100%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    totalFeeLeft: {
      textAlign: "left",
      paddingBottom: "32px",
      [theme.breakpoints.down("md")]: {
        paddingBottom: 0,
      },
    },
    totalFeeRight: {
      textAlign: "right",
      paddingBottom: "32px",
      color: colors.text.lightBlue,
      [theme.breakpoints.down("md")]: {
        paddingBottom: 0,
      },
    },
    itemValue: {
      fontSize: "16px",
      textAlign: "right",
      [theme.breakpoints.down("md")]: {
        fontSize: "14px",
      },
    },
    rowItem: {
      paddingBottom: "28px",
      [theme.breakpoints.down("md")]: {
        paddingBottom: "22px",
      },
    },
    iconVND: {
      fontWeight: 700,
      fontSize: "18px",
      color: "black",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
      },
    },
    errorText: {
      color: "red",
    },
  };
});

function openInCurrentTab(url) {
  let win = window.open(url, "_self");
  win.focus();
}
